import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-footer-slotted-contact-menu.css.lit';
import { SlotController } from '../../../controllers/slot-controller';

/**
 * The GhsFooterSlottedContactMenu component
 * @element ghs-footer-slotted-contact-menu
 * @slot - default slot
 */
@customElement('ghs-footer-slotted-contact-menu')
export class GhsFooterSlottedContactMenu extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  render(): TemplateResult {
    return html` <div class="footer-contact">
      <slot></slot>
    </div>`;
  }
}
